import { t } from '@lingui/core/macro';
import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';

export function OfflineBanner() {
  const isOnline = useOnlineStatus();

  if (isOnline) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-red-500 text-white px-4 py-3 shadow-lg">
      <div className="flex items-center justify-center gap-2">
        <WifiOff className="w-5 h-5" />
        <p className="font-medium">{t`No internet connection. Please check your network.`}</p>
      </div>
    </div>
  );
}
